import type { ReactNode } from "react";
import styled from "styled-components";
import { Alert, Box } from "@dealer-center/core-components";

const BannerContainer = styled(Box)`
  margin-bottom: 16px;
`;

export type BannerVariant = "error" | "info" | "success" | "caution";

export interface BannerProps {
  variant: BannerVariant;
  children: ReactNode;
  title?: string;
}

export const Banner = ({ variant, children, title }: BannerProps) => (
  <BannerContainer>
    <Alert
      data-testid="inventory-banner"
      role="alert"
      title={title}
      type={variant}
    >
      {children}
    </Alert>
  </BannerContainer>
);
